/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFPrivacyStatusEnum = {
    LoadFailure: 'load_failure',
    ParseFailure: 'parse_failure',
    Blocked: 'blocked',
    Success: 'success',
    ContentTooLarge: 'content_too_large',
    SkippedPolicy: 'skipped_policy',
    InvalidDomain: 'invalid_domain'
} as const;
export type CRSFPrivacyStatusEnum = typeof CRSFPrivacyStatusEnum[keyof typeof CRSFPrivacyStatusEnum];


export function CRSFPrivacyStatusEnumFromJSON(json: any): CRSFPrivacyStatusEnum {
    return CRSFPrivacyStatusEnumFromJSONTyped(json, false);
}

export function CRSFPrivacyStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFPrivacyStatusEnum {
    return json as CRSFPrivacyStatusEnum;
}

export function CRSFPrivacyStatusEnumToJSON(value?: CRSFPrivacyStatusEnum | null): any {
    return value as any;
}

